import _ from "lodash";

import React, {Component} from "react";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";

import {Button, Checkbox, Container, Table} from "semantic-ui-react";

import ajax from "../../helpers/ajax";

import {ERRORS_NEW, ERRORS_CLEAR} from "../../actions/types/types_errors";

import urls from "../../config/config";

import "./AudioHunter.css";


class AudioHunterCompany extends Component {
  constructor(props) {
    super(props);

    this.state = {
      imAgnieszka: false,
      btnText: "Migruj waćpanie!",
    };
  }

  migrate = () => {
    this.setState({btnText: "Migrujem!"});
    ajax.post(urls.AUDIO_HUNTER_COMPANY_MIGRATE)
      .then((response) => {
        this.setState({migrated: response.data.migrated, btnText: "Migruj waćpanie!"});
      });
  };

  getSummary = () => {
    let summary = new Set(_.map(this.state.migrated, (migrated) => migrated.username));

    return _.map(Array.from(summary), (user) => ({
      username: user,
      count: _.filter(this.state.migrated, {username: user}).length
    })
    );
  };

  renderMigrated = () => {
    return (
      <React.Fragment>
        <h2>
          Migrated
        </h2>
        <Table compact>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>
                Username
              </Table.HeaderCell>
              <Table.HeaderCell>
                Ans ID
              </Table.HeaderCell>
              <Table.HeaderCell>
                Q ID
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {
              _.map(this.state.migrated, (mig, idx) => (
                <Table.Row key={idx}>
                  <Table.Cell>
                    {mig.username}
                  </Table.Cell>
                  <Table.Cell>
                    {mig.ans_id}
                  </Table.Cell>
                  <Table.Cell>
                    {mig.q_id}
                  </Table.Cell>
                </Table.Row>
              )
              )
            }
          </Table.Body>
        </Table>
      </React.Fragment>
    );
  };

  renderSummary = () => {

    return (
      <React.Fragment>
        <h2>
          Summary
        </h2>
        <Table compact>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>
                Username
              </Table.HeaderCell>
              <Table.HeaderCell
              >
                Migrated count
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {
              _.map(this.getSummary(), (summary, idx) => (
                <Table.Row key={idx}>
                  <Table.Cell>
                    {summary.username}
                  </Table.Cell>
                  <Table.Cell>
                    {summary.count}
                  </Table.Cell>
                </Table.Row>
              )
              )
            }
          </Table.Body>
        </Table>
      </React.Fragment>
    );
  };

  render() {
    return (
      <Container className="AudioHunter">

        <div className={"inline-block"}>
          <h2>
            Migrate this
          </h2>
          <Checkbox
            checked={this.state.imAgnieszka}
            onChange={(e, {checked}) => {
              this.setState({imAgnieszka: checked});
            }}
            label={"Jestem Agnieszka, nie robot"}
          />
          <Button
            disabled={!this.state.imAgnieszka}
            content={this.state.btnText}
            color={"green"}
            onClick={this.migrate}
          />
        </div>
        <div className={"inline-block"}>
          {this.renderSummary()}
          {this.renderMigrated()}
        </div>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    errorsNew: (message) => dispatch({
      type: ERRORS_NEW,
      errors: message
    }),
    errorsClear: () => dispatch({
      type: ERRORS_CLEAR,
    })
  };
};

export default withRouter(connect(
  mapStateToProps, mapDispatchToProps
)(AudioHunterCompany));
